<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container fluid grid-list-xl py-0>
            <app-card customClasses="mb-30 elevation-5">
                <v-form>
                    <div class="subheading mb-3">Inserire il cognome e la data di nascita dell'abbonato</div>
                    <v-text-field required label="Cognome" v-model="searchModel.lastName"></v-text-field>
                    <v-layout row wrap>
                        <v-flex xs3>
                            <v-text-field required label="Giorno" v-model="searchModel.birthDateDay" type="text" pattern="\d*"></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                            <v-text-field required label="Mese" v-model="searchModel.birthDateMonth" type="text" pattern="\d*"></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field required label="Anno" v-model="searchModel.birthDateYear" type="text" pattern="\d*"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap center>
                            <v-flex xs12>
                                <div class="title text-xs-center" ref="errorMessage" v-if="nodata">
                                    <span class="red--text">{{errorMessage}}</span>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                <div class="text-xs-center">
                                    <v-btn center color="primary" large @click="search">Ricerca</v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </app-card>
            <app-card customClasses="mb-30 elevation-5" v-if="!nodata && !firstAccess">
                <div class="text-xs-center">
                    <h4 class="mb-0">Seleziona un nominativo per visualizzare i dettagli dell'abbonamento</h4>
                </div>
            </app-card>
            <v-card v-for="item in items" class="mx-auto mb-2 elevation-5">
                <v-card-text class="text-xs-center">
                    <h3 class="fw-bold">{{item.name}}</h3>
                    <v-btn large dark small color="green darken2" :to="{ name: 'abbonato', params: { id: item.id } }">
                        SELEZIONA
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>


<script>
    import Vue from "vue";
    import api from "Api";
    import moment from "moment";

    export default {
        data() {
            return {
                loader: true,
                nodata: false,
                errorMessage: "",
                firstAccess: true,
                items: [],
                searchModel: {
                    lastName: "",
                    birthDateDay: "",
                    birthDateMonth: "",
                    birthDateYear: ""
                }
            };
        },
        mounted() {
            
        },
        computed: {


        },
        methods: {
            search() {

                var instance = this;

                var request = {
                    lastName: this.searchModel.lastName,
                    birthDate: this.searchModel.birthDateYear + "-" + this.searchModel.birthDateMonth + "-" + this.searchModel.birthDateDay
                };

                api.instance
                    .post("controlloabbonamenti/search", request)
                    .then(response => {
                        instance.loader = false;
                        instance.firstAccess = false;
                        instance.error = false;
                        
                        if (response.data.status === "ok") {
                            if (response.data.isSingle) {
                                instance.$router.push({ name: 'abbonato', params: { id: response.data.customers[0].id } });
                            }
                            else {
                                instance.items = response.data.customers;
                            }
                        }
                        else {
                            instance.error = true;
                            instance.errorMessage = response.data.message;
                        }

                        instance.nodata = response.data.customers.length == 0;
                    })
                    .catch(error => {
                        Vue.notify({
                            type: 'warning',
                            text: 'Si � verificato un errore durante la richiesta. Riprovare o contattare l\'assistenza',
                            duration: 3000
                        });
                    });
            }
        }
    };</script>

